<template>
  <div>
    <v-tooltip location="bottom" nudge-bottom="15">
      <template #activator="{ props }">
        <small v-bind="props">
          <v-icon size="small">$iconReceipt</v-icon
          ><span class="ml-1">{{ carriageNumber || "???" }}</span>
        </small>
      </template>
      <span>
        {{
          $t(
            "events:appShowAthlete.drivingEquipageNumber.FEI.tooltip",
            "Driving equipage number"
          )
        }}
      </span>
    </v-tooltip>
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "AppShowCarriageNumber",
  props: {
    carriageNumber: {
      type: [String, Number],
      default: null
    }
  }
});
</script>
